import * as Sentry from "@sentry/browser";

export const initSentry = () => {
    if (SENTRY_DSN_FRONTEND) {
        Sentry.init({
            release: SENTRY_RELEASE,
            dsn: SENTRY_DSN_FRONTEND,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.captureConsoleIntegration(['warn', 'error']),
                // Sentry.replayIntegration(), // cpu usage problem
            ],
            environment: SENTRY_ENVIRONMENT,
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [baseUrl],
            // Session Replay
            replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            ignoreErrors: [
                'Could not load "util"' // google.maps error
            ],
            beforeSend(event) {
                if (event.hasOwnProperty('level') && event.level === 'info') {
                    return null;
                }

                if (event.message) {
                    // ignore IAB navigation logs from chrome and facebook on android
                    if (event.message.toLowerCase().includes('annav') || event.message.toLowerCase().includes('fbnav')) {
                        return null;
                    }

                    // ignore warnings that facebook is not updated
                    if (event.message.toLowerCase().includes('facebook')) {
                        return null;
                    }

                    // ignore warnings for "google.maps.event.addDomListener() is deprecated" - The feature will continue to work and there is no plan to decommission it.
                    if (event.message.toLowerCase().includes('google.maps.event.adddomlistener() is deprecated')) {
                        return null;
                    }

                    // ignore warnings for "Non-Error promise rejection captured with value: Object Not Found Matching Id:4, MethodName:update, ParamCount:4"
                    if (event.message.toLowerCase().includes('non-error promise rejection captured')) {
                        return null;
                    }

                    // ignore warnings for "Error: Java exception was raised during method invocation"
                    if (event.message.toLowerCase().includes('error: java exception')) {
                        return null;
                    }

                    // ignore warnings for "$ is not defined"
                    if (event.message.toLowerCase().includes('$ is not defined')) {
                        return null;
                    }

                    if (event.message.toLowerCase().includes('text_only') || event.message.toLowerCase().includes('dom_only') || event.message.toLowerCase().includes('text_and_dom')) {
                        return null;
                    }

                    if (event.message.toLowerCase().includes('requesting permission') || event.message.toLowerCase().includes('email permission granted')) {
                        return null;
                    }
                }

                return event;
            },
        });

        Sentry.setUser(user);
        Sentry.setTag('page_locale', entrioLang);
    }
};
